import { createAssessment, deleteAssessment, editAssessment, getAssessmentBiId, getAssessments, saveAssessment } from './assessment.action';
export { assessmentReducer } from './assessment.reducer';
export { watchAssessment } from './assessment.saga';

export const assessmentActions = {
    /** Assessments */
    getAssessments,
    getAssessmentBiId,
    createAssessment,
    saveAssessment,
    editAssessment,
    deleteAssessment,
    /** End */
};
